<template>
  <div class="vb">
    <v-icon class="vb-ico">
      mdi-history
    </v-icon>
    <div class="vb-text">
      <b>Версия от {{ date(snapshot.takenAt) }}</b>, до изменения
      <span v-if="snapshot.user">пользователя {{ snapshot.user.name }}</span>
      <span v-else>системы</span>
      ({{ sourceName }}). Зон в версии: {{ snapshot.zones.length }}. Пока открыт просмотр, правки отключены.
    </div>
    <v-btn
      v-if="canEdit"
      depressed
      small
      color="primary"
      class="vb-btn"
      @click="$emit('restore')"
    >
      Вернуть эту версию
    </v-btn>
    <v-btn
      depressed
      small
      outlined
      class="vb-btn"
      @click="$emit('exit')"
    >
      Выйти из просмотра
    </v-btn>
  </div>
</template>

<script>
  import { SOURCE_NAMES, historyDate } from './zonesHistoryText'

  /** Плашка режима просмотра версии: что показано на карте, как вернуть или выйти. */
  export default {
    name: 'VersionBanner',
    props: {
      snapshot: { type: Object, required: true },
      canEdit: { type: Boolean, default: false },
    },
    computed: {
      sourceName () {
        return (SOURCE_NAMES[this.snapshot.source] || this.snapshot.source || '').toLowerCase()
      },
    },
    methods: {
      date (s) {
        return historyDate(s)
      },
    },
  }
</script>

<style scoped>
  .vb {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #e8f1fd;
    border: 1px solid #c9dcf7;
    border-radius: 10px;
    padding: 7px 10px 7px 16px;
    color: #1f3b63;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .vb-ico {
    color: #1565c0;
    font-size: 20px;
  }
  .vb-text {
    flex: 1;
    min-width: 0;
  }
  .vb-btn {
    text-transform: none;
    letter-spacing: 0;
    border-radius: 8px;
  }
</style>
